<header-bar pageTitle="Drop down configuration" headingClass="fa-list"></header-bar>
<router-outlet></router-outlet>